import { currentLocale } from '@web/i18n';

/**
 * Formats a `Date` or ISO string as numeric day and month in the UI locale
 * (`dd/mm` in pt-BR, `mm/dd` in en), `''` when unparseable —
 * the calendar-day twin of {@link formatHhMm}, same `timeZone` contract (an
 * IANA zone to render in; the browser's own when omitted).
 */
export function formatDdMm(input: Date | string, options: { timeZone?: string } = {}): string {
  const d = typeof input === 'string' ? new Date(input) : input;
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(currentLocale(), {
    day: '2-digit',
    month: '2-digit',
    timeZone: options.timeZone,
  });
}

/**
 * The calendar day of an instant in a zone, as a sortable `YYYY-MM-DD` key —
 * what "is this flight today?" compares, so two instants on the same day in
 * the airport's zone match even when one is already tomorrow in UTC.
 */
export function calendarDayKey(input: Date | string, options: { timeZone?: string } = {}): string {
  const d = typeof input === 'string' ? new Date(input) : input;
  if (Number.isNaN(d.getTime())) return '';
  // `en-CA` is the one locale whose default numeric date is ISO-ordered.
  return d.toLocaleDateString('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: options.timeZone,
  });
}
